exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".interactive-survey-message-ask-buttons .btn{margin:10px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/chat/interactiveSurvey/styles/ask.scss
// module id = 1162
// module chunks = 0 1